import React from "react";
import { connect } from "react-redux";
import AddIcon from "../UIComponents/AddIcon";
import MDCard from './MDCard';
import DatePicker from 'react-datepicker';
import Moment from 'moment';
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import 'react-datepicker/dist/react-datepicker.css';
const SearchItem = { minyear: '', mdidno: '', maxyear: '', supplier: '', sdocid: '', productname: '', productnumber: '', sortorder: 'asc', sortby: 'productname', pagesize: 25, pagenumber: 1 }
class MDLibrary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedFromDate: '', SelectedToDate: '',
      fromDate: '', toDate: '',
      fromDatePickerIsOpen: false, toDatePickerIsOpen: false,
      searchDate: { minyear: '', mdidno: '', maxyear: '', supplier: '', sdocid: '', productname: '', productnumber: '', sortorder: 'asc', sortby: 'productname', pagesize: 25, pagenumber: 1 }
    };
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.SearchMDData = this.SearchMDData.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch } = nextProps;
    if (nextProps.isMDSearch && nextProps.showSidePane) {
      prevState.searchDate = nextProps.MDSearchData
    }
    if ((nextProps.MDDeleteSuccess && !nextProps.showSidePane) || nextProps.ResetMI === true) {
      prevState.searchDate = nextProps.MDSearchData
      dispatch(getMDSearchlist(prevState.searchDate));
      dispatch({ type: "ResetMI", data: false })
    }
  }

  componentDidMount() {
    this.props.dispatch(getMDSearchlist(this.state.searchDate));
    this.props.dispatch({ type: 'SubBannerTitle', data: "MD Library" });
  }

  SearchMDData(pgno) {
    this.state.searchDate['pagenumber'] = pgno;
    const { dispatch } = this.props;
    dispatch({ type: "SearchMDLibraryData", data: this.state.searchDate })
    dispatch(getMDSearchlist(this.state.searchDate));
    dispatch({ type: "ResetMD", data: true })
  }

  SearchMDList(pgno) {
    this.state.searchDate['pagenumber'] = pgno;
    const { dispatch } = this.props;
    dispatch(getMDSearchlist(this.state.searchDate));
  }

  ClearSearchField() {
    let param = { ...SearchItem }
    this.setState({
      searchDate: param
    }, () => {
      this.props.dispatch(getMDSearchlist(this.state.searchDate));
    })
  }

  handleFromDateChange(date) {
    this.state.searchDate.minyear = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false
    })
  }

  handleToDateChange(date) {
    this.state.searchDate.maxyear = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false
    });
  }

  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  };

  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  };

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  handleRadioButtonChanges(e) {
    this.state.searchDate[e.target.name] = this.refs.check_me.checked ? 'asc' : 'desc';
    this.setState({

    })
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchDate[nodeName] = e.target.value;
    this.setState({

    });
  }

  hideSidePanel = () => {
    this.props.history.goBack();
    this.props.dispatch({ type: "ShowSidePan", data: false });
  }

  render() {
    const {
      showSidePane, arraylist, MDLib
    } = this.props;
    return (
      <div className="full-height">
        <button
          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3 mx-4"
          onClick={() => this.hideSidePanel()}
        >
          &larr; Back
                        </button>
        {/* <div hidden={!MDLib}> */}
        {/* <div className={!showSidePane ? "row mr-2 " : "row"} style={{ height: "50px" }}>
            {!showSidePane ? <div className="ml-auto m-3 nav-item-link" onClick={this.MDNewitemNav} style={{ color: "#109AFF" }}>New Item</div> : ''}
          </div> */}
        <div className="grey-bg  course-list-page">
          <div className="px-4 pt-3">
            <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
              <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                  MD Library
                  </h5>
                <div className="m-1 flex" onClick={this.MDNewitemNav}>
                  <span className="mt-1">Add</span><AddIcon />
                </div>
              </div>
            </div>
            <div className="panel-box  search-filter-box mb-3">
              <div className="row" style={{ paddingBottom: '12px' }}>
                <div className={showSidePane ? "col-lg-6  col-sm-12 col-xs-12" : "col-lg-4  col-sm-12 col-xs-12"}>
                  <label className="form-label" >Date of Declaration</label><br></br>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className='input-group add-on date datepicker' data-date-format="yyyy-mm-dd">
                        <input type="text" value={this.state.searchDate.minyear} className="form-control date-picker" placeholder="From Date" name='fromDate'></input>
                        <DatePicker selected={this.state.SelectedFromDate} onChange={this.handleFromDateChange}
                          open={this.state.fromDatePickerIsOpen} onClickOutside={this.handleBlur}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          popperPlacement="top-end"
                          className="form-control date-picker w-5 hide-date" />
                        <div className="input-group-btn calendar-icon" onClick={this.openFromDatePicker}>
                          <button className="btn btn-default">
                            <i className="fa fa-calendar mt-1"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6  margin">
                      <div className='input-group add-on date datepicker'
                        data-date-format="yyyy-mm-dd">
                        <input value={this.state.searchDate.maxyear} type="text" placeholder="To Date" className="form-control date-picker" name='toDate'
                          data-date-format="yyyy-mm-dd" />
                        <DatePicker selected={this.state.SelectedToDate} onChange={this.handleToDateChange}
                          open={this.state.toDatePickerIsOpen} onClickOutside={this.handleBlur}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          popperPlacement="top-end"
                          className="form-control date-picker w-5 hide-date" />
                        <div className="input-group-btn calendar-icon">
                          <button className="btn btn-default" onClick={this.openToDatePicker}>
                            <i className="fa fa-calendar mt-1" ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                  <label className="form-label" >MD ID No</label><br></br>
                  <input className="form-control" type="text" name="mdidno" onChange={this.handleInputChange.bind(this)} value={this.state.searchDate.mdidno}></input>
                </div>
                <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                  <label className="form-label">Supplier</label><br></br>
                  <input className="form-control" type="text" name="supplier" onChange={this.handleInputChange.bind(this)} value={this.state.searchDate.supplier}></input>
                </div>
                <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                  <label className="form-label" >SDoC ID No</label><br></br>
                  <input className="form-control" type="text" name="sdocid" onChange={this.handleInputChange.bind(this)} value={this.state.searchDate.sdocid}></input>
                </div>
                <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                  <label className="form-label">Product Name</label><br></br>
                  <input className="form-control" type="text" name="productname" onChange={this.handleInputChange.bind(this)} value={this.state.searchDate.productname}></input>
                </div>
                <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                  <label className="form-label" name="productnumber">Product Number</label><br></br>
                  <input className="form-control" type="text" name="productnumber" onChange={this.handleInputChange.bind(this)} value={this.state.searchDate.productnumber}></input>
                </div>
                <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                  <label className="form-label"  >Display Result Count</label><br></br>
                  <select className="form-control" name="pagesize" onChange={this.handleInputChange.bind(this)} value={this.state.searchDate.pagesize}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                  <label className="form-label" >Sort by</label><br></br>
                  <div className="row">
                    <div className={showSidePane ? "col-lg-5 " : "col-lg-6 "}>
                      <select className="form-control" name="sortby" onChange={this.handleInputChange.bind(this)} value={this.state.searchDate.sortby}>
                        <option value="productname" >Product name</option>
                        <option value="companyname">Supplier</option>
                        <option value="dateofdeclaration">Date of declaration</option>
                      </select>
                    </div>
                    <div className={showSidePane ? "col-sm-3 mt-2" : "col-sm-3 mt-2"}>
                      <input type="radio" name="sortorder" checked={this.state.searchDate.sortorder === 'asc'} ref="check_me" onChange={this.handleRadioButtonChanges.bind(this)}>
                      </input><span className="ml-1">Asc</span></div>
                    <div className={showSidePane ? "col-sm-4 mt-2" : "col-sm-3 mt-2"}>
                      <input type="radio" name="sortorder" checked={this.state.searchDate.sortorder === 'desc'} onChange={this.handleRadioButtonChanges.bind(this)}></input><span className="ml-1">Desc</span>
                    </div>
                  </div>
                </div>
                <div className={showSidePane ? "col-lg-12 mt-2" : "col-lg-4"}>
                  <label className="form-label" ></label><br></br>
                  <div className="mt-3 search-btn-col" style={{ textAlign: 'end' }}>
                    <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.SearchMDData(1)}> Search </button>

                    <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.ClearSearchField()}> Clear </button>
                  </div>
                </div>
              </div>
            </div>
            {arraylist ?
              <MDCard arraylist={arraylist} pageSize={this.state.searchDate.pagesize} setUpdatedState={value => this.SearchMDList(value)} /> : null}
          </div>
        </div>
        {/* </div> */}
      </div>


    );
  }

  MDNewitemNav = () => {
    this.props.dispatch({ type: 'MaterialDeclarationOptions', data: "Add" });
    this.props.dispatch({ type: 'Otherpages' });
    this.props.dispatch({ type: "GetMaterialDeclarationSuccess", data: {} });
    this.props.history.push("/Home/MDAdmin");
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    materialDeclarationslist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    MDLib: state.SidePanReducer.MDLib,
    ResetMI: state.SidePanReducer.ResetMI
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(MDLibrary);